import React from 'react';
import { Helmet } from 'react-helmet-async';

const ProductSchema = ({ product, salePrice = null }) => {
  if (!product) return null;

  const schema = {
    "@context": "https://schema.org/",
    "@type": "Product",
    "name": product.name,
    "description": product.description,
    "image": product.images || [],
    "sku": product.sku,
    "brand": {
      "@type": "Brand",
      "name": "Rizzahra"
    },
    "offers": {
      "@type": "Offer",
      "url": `https://rizzahra.store/product/${product.id}`,
      "priceCurrency": "PKR",
      "price": salePrice || product.price,
      "priceValidUntil": "2026-12-31",
      "availability": product.stock > 0 ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
      "itemCondition": "https://schema.org/NewCondition"
    }
  };

  // Add aggregateRating if available
  if (product.rating && product.reviewCount) {
    schema.aggregateRating = {
      "@type": "AggregateRating",
      "ratingValue": product.rating,
      "reviewCount": product.reviewCount
    };
  }

  // Add category
  if (product.category) {
    schema.category = product.category;
  }

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export default ProductSchema;
